import { c as e } from "./_commonjsHelpers.DaMA6jEr.js";
var s = typeof e == "object" && e && e.Object === Object && e, j = s, v = j, T = typeof self == "object" && self && self.Object === Object && self, S = v || T || Function("return this")(), y = S, O = y, d = O.Symbol, i = d, o = i, c = Object.prototype, u = c.hasOwnProperty, m = c.toString, r = o ? o.toStringTag : void 0;
function p(t) {
  var b = u.call(t, r), f = t[r];
  try {
    t[r] = void 0;
    var g = !0;
  } catch {
  }
  var l = m.call(t);
  return g && (b ? t[r] = f : delete t[r]), l;
}
var $ = p, _ = Object.prototype, w = _.toString;
function G(t) {
  return w.call(t);
}
var h = G, a = i, P = $, R = h, k = "[object Null]", L = "[object Undefined]", n = a ? a.toStringTag : void 0;
function x(t) {
  return t == null ? t === void 0 ? L : k : n && n in Object(t) ? P(t) : R(t);
}
var q = x;
function F(t) {
  return t != null && typeof t == "object";
}
var z = F;
export {
  q as _,
  i as a,
  y as b,
  j as c,
  z as i
};
//# sourceMappingURL=isObjectLike.YJTOHc8M.js.map
